import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import Landing from "../pages/Landing";

/**
 * `/` has two personalities:
 *  - public visitor → luxury marketing landing page (Landing.jsx)
 *  - authenticated user → dashboard Home, inside Layout (handled by the
 *    protected route tree in App.js)
 *
 * During auth bootstrap we show the same quiet "Cadence" splash the
 * ProtectedRoute uses, so the experience is consistent.
 */
export default function RootRoute() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div
                className="min-h-screen flex items-center justify-center text-stone-500"
                data-testid="root-loading"
            >
                <div className="font-serif italic text-2xl">Cadence</div>
            </div>
        );
    }

    if (user) {
        // Not-onboarded users always go through onboarding first.
        if (!user.onboarded) return <Navigate to="/onboarding" replace />;
        // Delegate authenticated home to the existing protected Layout+Home route.
        return <Navigate to="/home" replace />;
    }

    return <Landing />;
}
